import {getTitleForView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {PipelineStep, PipelineViewGraphQL} from 'pipelines/PipelineTypes';

/**
 * Find a matching view by exact case-insensitive name comparison against analysis table names.
 */
export function findMatchingViewByName(
  variableName: string,
  candidateViews: ReadonlyArray<PipelineViewGraphQL>,
  steps: ReadonlyArray<PipelineStep>
): PipelineViewGraphQL | null {
  const targetName = variableName.toLowerCase();

  for (const view of candidateViews) {
    const title = getTitleForView(view, steps);
    if (title.toLowerCase() === targetName) {
      return view;
    }
  }

  return null;
}
